function TopBar() {
  return (
    <div className="top-bar">
      <div className="top-bar-content">
        <span>✉ recruitment@zethhealth.ca</span>
        <span>☎ +1 (647) 555-0198</span>
      </div>

      <div className="social-links">
        <span>in</span>
        <span>f</span>
        <span>◎</span>
      </div>
    </div>
  );
}

export default TopBar;